import React from "react";
import * as Styles from "./CarDeliveryAddressResult.styles";
import Icon from "../../../../../shared-components/lexus/styles/atoms/Icon";

type CarDeliveryAddressResultProps = {
    address: string;
    selectLocation?: () => void;
};

const CarDeliveryAddressResult = ({ address, selectLocation }: CarDeliveryAddressResultProps): JSX.Element => {
    return (
        <Styles.AddressResultWrapper tabIndex={0} role="option" onClick={selectLocation}>
            <Icon variant="location" />
            <Styles.AddressResultEllipsis>{address}</Styles.AddressResultEllipsis>
        </Styles.AddressResultWrapper>
    );
};

export default CarDeliveryAddressResult;
